export const DOC_CATEGORIES = ["SAFE", "Term Sheet", "Cap Table", "Board Deck", "Financials", "Report", "Legal", "Other"];

export const RIGHT_DEFS = [
  { k: "monthly_updates", label: "Monthly update reports" },
  { k: "quarterly_financials", label: "Quarterly financials" },
  { k: "annual_audited_financials", label: "Annual audited financials" },
  { k: "cap_table_access", label: "Cap table access" },
  { k: "board_materials", label: "Board materials / observer" },
  { k: "budget_access", label: "Annual budget / operating plan" },
  { k: "inspection_rights", label: "Books & records inspection" },
  { k: "pro_rata_rights", label: "Pro-rata rights" },
  { k: "mfn", label: "Most-favored-nation" },
];

export const CADENCES = ["weekly", "monthly", "quarterly", "annual"];
